//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SocialShare",
  props: {
    placeholder_image: String,
    name: String,
    selling_price: Number,
    brand: String,
  },
  data: function () {
    return {
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: "fa fa-facebook-f",
          color: "#1877f2",
          key: 1,
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "fa fa-whatsapp",
          color: "#25d366",
          key: 2,
        },
      ],
      pro_url_key: this.$route.fullPath.substring(1,this.$route.fullPath.length),
      shareIcon: false,
    };
  },
  methods: {
    shareIconbtn(){
        this.shareIcon = !this.shareIcon
    }
  }
};
